<template>
    <a
    href="#"
    @click.prevent="onClick"
    :class="classes"
    >
        <div class="notifications-item__icon">
            <i class="material-icons">
                {{ icon }}
            </i>
        </div>
        <div class="notifications-item__content">
            <div
                class="notifications-item__title"
                v-html="message"
            ></div>
            <div class="notifications-item__date">
                {{ date }}
            </div>
        </div>
    </a>
</template>

<script>
import moment from 'moment'
export default {
    name: 'notification-item',
    props: {
        notification: {
            type: Object,
            required: true,
        },
        isLast: {
            type: Boolean,
        }
    },
    computed: {
        classes () {
            return {
                'notifications-item': true,
                'notifications-item--unread': this.notification.unread,
                'notifications-item--is-last': this.isLast,
            }
        },
        icon () {
            const icons = {
                contact: 'contacts',
                newsletter: 'local_post_office',
                comments: 'chrome_reader_mode',
            }
            return icons[this.notification.table_name]
        },
        date () {
            return moment(this.notification.createdAt).format('DD/MM/YYYY HH:mm')
        },
        message () {
            return this.notification.message
        }
    },
    methods: {
        onClick () {
            const paths = {
                newsletter: () => '/newsletter',
                contact: () => '/contacts',
                comments: () => '/blog/comments',
            }
            const path = paths[this.notification.table_name]
                ? paths[this.notification.table_name]()
                : '/'
            if (this.$route.path !== path) {
                this.$router.push(path)
            }
            this.$emit('click', this.notification)
        }
    }
}
</script>

<style lang="scss">
.notifications-item {
    @extend %default-borderRadius;
    display: flex;
    margin: 0 0 5px 0;
    padding: 10px;
    color: inherit;
    text-decoration: none;
    background: #e9e9e9;
    align-items: flex-start;
    &__content {
        margin-left: 10px;
        flex-grow: 1;
    }
    &__title {
        font-size: 16px;
        strong {
            font-weight: 500;
        }
    }
    &__date {
        margin: 3px 0 0 0;
        font-size: 12px;
    }
    &:hover {
        background: #eee;
    }
    &--unread {
        background: #FEC402;
        &:hover {
            background: #ffcf31;
        }
    }
    &--is-last {
        position: relative;
        margin-bottom: 30px;
        &::after {
            content: "";
            position: absolute;
            display: block;
            left: 50%;
            transform: translateX(-50%);
            bottom: -15px;
            width: 20%;
            border-bottom: 1px solid #ccc;
        }
    }
}
</style>
